import { Button, Grid, styled, TextField, Typography } from '@mui/material';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

export const GridContainer = styled(Grid)`
  width: 100%;
  margin: 0;
  padding-right: 16px;
  & .MuiGrid-container {
    padding-top: 16px;
  }
`;

export const Title = styled(Typography)`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.125rem;
`;

export const InputTextField = styled(TextField)`
  width: 100%;
  & .MuiFilledInput-input {
    padding-top: 12px;
  }
`;

export const AddBackupButton = styled(Button)`
  width: 130px;
`;

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.brand.lightBlue,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.brand.lightBlue,
    color: theme.palette.text.primary,
    fontFamily: 'Roboto',
    fontSize: '0.875rem',
    padding: '15px',
    fontWeight: '300',
  },
}));

export const PreviewGrid = styled(Grid)(
  ({ $isConfirmation }) => `
margin-bottom: ${$isConfirmation === 'true' ? '90px' : '0'};
`,
);
